export function slugify(input: string): string {
  return (input || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
    .slice(0, 60);
}

export const PUBLIC_TAGS = ['kids', 'pet', 'family', 'lgbt', 'parking'] as const;
export type PublicTag = (typeof PUBLIC_TAGS)[number];
